import { render, staticRenderFns } from "./contentDimensionType.vue?vue&type=template&id=31946154&scoped=true"
import script from "./contentDimensionType.vue?vue&type=script&lang=js"
export * from "./contentDimensionType.vue?vue&type=script&lang=js"
import style0 from "./contentDimensionType.vue?vue&type=style&index=0&id=31946154&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31946154",
  null
  
)

export default component.exports